import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { RegistroDocumentacion } from '../Modelos/RegistroDocumentacion';

@Injectable({
    providedIn: 'root'
})
export class DocumentacionService{

    constructor(){}

    async consultarDocumentacion(codigoSucursal: number, codigoAgente: number){

        let url = new URL(`${environment.backendUrl}/api/Semaforo/Semaforo`);
        let parameters={
            cod_sucursal: codigoSucursal,
            cod_agente: codigoAgente
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
        return await (await fetch(url.toString(), {method: 'GET'})).json();
    }

    async consultarDocumentacionCargada(codigoSucursal: number, codigoAgente: number){
        let url = new URL(`${environment.backendUrl}/api/Semaforo/DocumentacionRecibida`);
        let parameters={
            cod_sucursal: codigoSucursal,
            cod_agente: codigoAgente
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
        return await (await fetch(url.toString(), {method: 'GET'})).json();
    }

    async guardarDocumentacion(documentacionASubir: RegistroDocumentacion, archivoASubir: {valor: string, extension: string, codigo: number}, usuario: string = "") {

        let url=`${environment.backendUrl}/api/Documentacion/SubirDocumentacion?usuario=${usuario}`;
        let archivo=archivoASubir.valor.split(",");

        let object={
            str_extension: archivoASubir.extension,
            str_nro_documento: documentacionASubir.numeroDocumento.toString(),
            str_encabezado: archivo[0],
            str_documento: archivo[1],
            in_cod_suc: documentacionASubir.codigoSucursal,
            in_cod_ramo: documentacionASubir.codigoRamo,
            nro_poliza: documentacionASubir.numeroPoliza,
            in_cod_proceso: documentacionASubir.codigoProceso,
            in_cod_documento: archivoASubir.codigo
        };
        let json=JSON.stringify(object);

        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };

        return await (await fetch(url, request)).json();
    }

    async finlecoToCumplimiento(payload: any, usuario: string = "") {
        let url=`${environment.backendUrl}/api/Documentacion/ConsultarDocumentosCargadoFinleco?usuario=${usuario}`;
      
        let json=JSON.stringify(payload);
    
        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };
    
        return await (await fetch(url, request)).json();
      }

    async consultarDocumentosPorRamo(codigoRamo: number, codigoProceso: number){
        let url=new URL(`${environment.backendUrl}/api/Documentacion/ConsultarDocumentosxRamo`);
        let parameters={
            cod_ramo: codigoRamo==null?0:codigoRamo,
            cod_proceso: codigoProceso==null?0:codigoProceso
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).json();
        return object;
    }

    async consultarDocumentosPorRamoCargados(codigoRamo: number, codigoProceso: number){
        let url=new URL(`${environment.backendUrl}/api/Documentacion/ConsultarDocumentosxRamoRecibidos`);
        let parameters={
            cod_ramo: codigoRamo==null?0:codigoRamo,
            cod_proceso: codigoProceso==null?0:codigoProceso
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).json();
        return object;
    }

    async obtenerBase64DesdeRuta(ruta: string){
        let url=new URL(`${environment.backendUrl}/api/Documentacion/ConsultarDocumentosCargado`);
        let parameters={
            ruta: ruta
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).text();
        return object;
    }

    async obtenerEncabezado(codigoRamo: number, codigoProceso: number, codigoDocumento: number){
        let url=new URL(`${environment.backendUrl}/api/Documentacion/ConsultarDocumentosxRamoRecibidos`);
        let parameters={
            cod_ramo: codigoRamo,
            cod_proceso: codigoProceso
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object: any[]=await (await fetch(url.toString(), {method: 'GET'})).json();
        let encabezado=object.find(x => x.codigo_documento==codigoDocumento).encabezado;
        return encabezado;
    }
}
